import type { SitecoreProductAdsFieldData } from './fields/types/home-page'
import type { MvcComponentData } from '@/cms/types'
import * as React from 'react'

import { TEMPLATE_NAMES } from '@/cms/constants/template-names'
import { Footer } from '@/scopes/common/components'
import { CatalogueContent } from '@/scopes/common/components/Footer/CatalogueContent'
import { NonCatalogueContent } from '@/scopes/common/components/Footer/NonCatalogueContent'
import { Header } from '@/scopes/common/components/Header'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import ContentUsps from '@/scopes/content/components/ContentUsps/ContentUsps'
import { SnowInfoHeader } from '@/scopes/content/components/SnowInfoHeader/SnowInfoHeader'
import { Trustpilot } from '@/scopes/content/components/Trustpilot/Trustpilot'
import { SummerWeatherGraph } from '@/scopes/content/components/Weather/SummerWeatherGraph'
import { WinterWeatherReport } from '@/scopes/content/components/Weather/WinterWeatherReport'
import { HomeTileProductAds } from '@/scopes/product-ads/components/HomeTile'
import { ProductAdsBanner } from '@/scopes/product-ads/components/ProductAdsBanner'
import { QuickSearch } from '@/scopes/search/quick-search/components'
import { HybridSearchPage } from '@/scopes/search/search/pages/SearchPage/SearchPage'
import InstagramFeed from '@/scopes/social/components/InstagramFeed'

const renderSummerWeatherGraph = () => <SummerWeatherGraph />
const renderWinterWeatherReport = () => <WinterWeatherReport />

const CONTENT_USPS_TEMPLATE_NAMES: string[] = [
  TEMPLATE_NAMES.HomePage,
  TEMPLATE_NAMES.BrandSummerHomePage,
  TEMPLATE_NAMES.BrandWinterHomePage,
]

function isTemplateWithReactContentUsps(templateName?: string) {
  if (!templateName)
    return false

  return CONTENT_USPS_TEMPLATE_NAMES.includes(templateName)
}

// Register React components here if you migrate from MVC to React
export function getComponentIndex(catalogueType: CatalogueType, templateName?: string): Record<string, React.ComponentType<any>> {
  const hasCatalogue = catalogueType !== CatalogueType.None

  return {
    SearchBlock: () => <HybridSearchPage />,
    SearchComponent: () => <HybridSearchPage isLandingPage />,
    QuickSearch: () => <QuickSearch catalogueType={catalogueType} />,
    Header: () => <Header hideLiveSearch={!hasCatalogue} />,
    Footer: () => (
      <Footer>
        {hasCatalogue ? <CatalogueContent /> : <NonCatalogueContent />}
      </Footer>
    ),
    ProductAds: (data: MvcComponentData<SitecoreProductAdsFieldData>) => (
      <HomeTileProductAds
        contextItemId={data.renderingContext.item.id}
        headerTitle={data.renderingContext.item.fields.title}
        infoLabel={data.renderingContext.item.fields.infotitle}
        infoContent={data.renderingContext.item.fields.infocontent}
      />
    ),
    ProductAdsBanner: () => <ProductAdsBanner componentType="LandingBanner" />,
    ...(isTemplateWithReactContentUsps(templateName) && { ContentUsps: () => <ContentUsps /> }),
    Trustpilot: () => <Trustpilot />,
    CountryWeatherGraph: renderSummerWeatherGraph,
    RegionWeatherGraph: renderSummerWeatherGraph,
    CityWeatherGraph: renderSummerWeatherGraph,
    HistoricalSnowStats: renderWinterWeatherReport,
    InstagramFeed: () => <InstagramFeed />,
    SnowInfoHeader: () => <SnowInfoHeader />,
  }
}
